/**
 * Очередь с ограничением параллельности.
 *
 * PART 3, раздел 3: список событий не должен превращаться в N+1 обстрел
 * бэкенда. Строка запрашивает превью только когда попала во вьюпорт, а очередь
 * держит одновременно не больше `limit` запросов. Ушедшая из вьюпорта строка
 * снимает свою задачу, если та ещё не стартовала.
 *
 * Модуль намеренно без React: логика параллельности проверяется юнит-тестами.
 */

export const CANCELLED = new Error('evidence-task-cancelled');

export const createTaskQueue = (limit = 4) => {
  const pending = [];
  let active = 0;

  // Вынесено вне цикла, чтобы избежать повторного замыкания на active в каждой итерации.
  const runJob = (job) => {
    active += 1;
    Promise.resolve()
      .then(job.task)
      .then(job.resolve, job.reject)
      .then(() => {
        active -= 1;
        pump();
      });
  };

  const pump = () => {
    while (active < limit && pending.length > 0) {
      const job = pending.shift();
      if (job.cancelled) continue;

      runJob(job);
    }
  };

  const enqueue = (task) => {
    const job = { task, cancelled: false, resolve: null, reject: null };
    const promise = new Promise((resolve, reject) => {
      job.resolve = resolve;
      job.reject = reject;
    });

    pending.push(job);
    pump();

    return {
      promise,
      cancel: () => {
        if (job.cancelled) return;
        job.cancelled = true;
        job.reject(CANCELLED);
      },
    };
  };

  return {
    enqueue,
    activeCount: () => active,
    pendingCount: () => pending.length,
  };
};

/** Общая очередь приложения: лимит 4 задан ТЗ. */
export const evidenceQueue = createTaskQueue(4);
